import { simpleSet } from '@r/reducers/utils';

const setCalculationModeDrawerSystemsValue = simpleSet as
  redux.reducers.calculationMode.settings.materials.drawerSystems.value;

export const value = setCalculationModeDrawerSystemsValue(
  'SET_CALCULATION_MODE_DRAWER_SYSTEMS_VALUE',
  { value: '', label: '' }
);
